import { gql } from 'graphql-tag';

export * from '../../../../src/graphql/queries';
export const PrivatePosts = gql`
  query PrivatePosts(
    $userIds: [ID!]!
    $filter: PrivatePostFilter!
    $after: String
  ) {
    privatePosts(userIds: $userIds, filter: $filter, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...PostDetails
        }
      }
    }
  }
`;

export const RecentConversationTitlePosts = gql`
  query RecentConversationTitlePosts(
    $userIds: [ID!]!
    $filter: PrivatePostFilter!
    $first: Int
  ) {
    privatePosts(userIds: $userIds, filter: $filter, first: $first) {
      edges {
        node {
          id
          ... on ActivePost {
            metadata
          }
        }
      }
    }
  }
`;

export const UserPosts = gql`
  query UserPosts(
    $userIds: [ID!]!
    $projectId: ID!
    $cohortId: ID
    $filter: PrivatePostFilter!
    $after: String
  ) {
    userPosts(
      userIds: $userIds
      projectId: $projectId
      cohortId: $cohortId
      filter: $filter
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...PostDetails
        }
      }
    }
  }
`;

export const Conversations = gql`
  query Conversations($first: Int, $after: String) {
    conversations(first: $first, after: $after) {
      edges {
        node {
          conversationId
          displayTitle
          userIds
          latestMessageText
          latestMessageTime
          latestMessageUserId
          hasUnread
        }
      }
    }
  }
`;
